export default __webpack_public_path__ + "static/media/user-icon.bb949685.svg";